<template>
  <div v-if="visible" class="insufficient-overlay" @click.self="close">
    <div class="insufficient-dialog">
      <img :src="popupImg" class="popup-illustration" alt="积分余额不足" />
      <div class="dialog-body">
        <h2 class="insufficient-title">积分余额不足</h2>
        <p class="insufficient-desc">当前积分不足，无法完成本次操作</p>
        <button class="insufficient-btn" @click="goRecharge">去充值</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsufficientDialog',
  data() {
    return {
      popupImg: require('../assets/images/noTokenPopup.png')
    }
  },
  computed: {
    visible() {
      return this.$store.state.showInsufficientDialog
    }
  },
  methods: {
    close() {
      this.$store.commit('SET_INSUFFICIENT_DIALOG', false)
    },
    goRecharge() {
      this.close()
      this.$router.push('/credits')
    }
  }
}
</script>

<style scoped>
.insufficient-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(4px);
  z-index: 2500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: fadeIn 0.2s ease;
}

.insufficient-dialog {
  border-radius: 16px;
  width: min(438px, 92vw);
  max-width: 438px;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  animation: scaleIn 0.25s ease;
  position: relative;
}

.popup-illustration {
  width: 100%;
  height: auto;
  display: block;
}
.dialog-body {
  z-index: 100;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 clamp(20px, 6vw, 30px) clamp(18px, 5vw, 28px);
  text-align: center;
  box-sizing: border-box;
}

.insufficient-title {
  font-weight: bold;
  font-size: clamp(20px, 6vw, 38px);
  color: #292F40;
  margin: 0 0 6px;
}

.insufficient-desc {
  font-size: clamp(14px, 4vw, 18px);
  color: #7A5465;
  margin: 0 0 clamp(24px, 6vw, 50px);
  line-height: 1.5;
}

.insufficient-btn {
  width: 100%;
  height: clamp(48px, 14vw, 82px);
  border: none;
  border-radius: clamp(24px, 7vw, 41px);
  background: #0059D4;
  color: #fff;
  font-size: clamp(15px, 4vw, 18px);
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.insufficient-btn:hover {
  opacity: 0.9;
}

/* 大屏固定宽度，避免被拉伸 */
@media (min-width: 768px) {
  .insufficient-dialog {
    width: 438px;
  }
}

/* 超小屏减少外边距，避免贴边 */
@media (max-width: 360px) {
  .insufficient-overlay {
    padding: 12px;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>
